import React from 'react';
import DataCheckpoint from './DataCheckpoint';

const DetailLacak = ({ detailOrder, onClose }) => {
  return (
    <div className='lacak-panel'>
      <div className='lacak-panel__scroll'>
        <DataCheckpoint order_id={detailOrder.order_id} />
      </div>
      <div className='lacak-panel__footer'>
        <button type='button' className='sb-btn sb-btn--neutral' onClick={onClose}>
          Tutup
        </button>
      </div>
    </div>
  );
};

export default DetailLacak;
